import { DefaultTheme } from 'styled-components/dist/types';
import { getRGBA } from 'styles/utils';

/** 
 These styles refer to the Container sections inside flowable design
 The components customized in this file are:
 - Modal
 - Wizard
 - Tabs
 */
export const getFlowableModalStyles = ({ theme }: { theme: DefaultTheme }): string => {
  return `
  .flw__modal-panel__dialog {
    overflow-y: auto;
    padding: 0;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    position: fixed;
    inset: 0px;
    background: ${getRGBA(theme.color.modal_dialog.overlay_background, 0.5)};
    opacity: 1;
    z-index: 2;
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
    width: 100%;
    max-width: 100%;
    border-radius: none;
  }

  .flw__modal-panel__dialog,
  .flw__action__modal__dialog,
  .flw-formDialog__content--medium {
    width: 100%;
    max-width: 100%;
    border-radius: none;
    overflow-y: hidden;
  }

  .flw__modal-panel__dialog__body,
  .flw__modal-panel__dialog__body .flw__form-wrap,
  .flw__modal-panel__dialog__body .flw__panel.flw__flw-form {
    background-color: ${theme.color.modal_dialog.background};
    ${theme.radii.radius12};
    max-height: 90%;
    overflow-y: auto;
  }  
  
  .flw__modal-panel__dialog__body .flw__action__confirmation-title {
    color: ${theme.color.general.font.primary};
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    @media (max-width: 320px) {
      font-size: 20px;
      line-height: 28px;
    }
  }
  `
}

export const getFlowableWizardStyles = ({ theme }: { theme: DefaultTheme }): string => {
  return `
  .flw__wizard__stages__stage {
    color: ${theme.color.general.font.quaternary};
  }
  .flw__wizard__stages__stage:after {
    display: none;
  }
  .flw__wizard__stages__stage:before {
    border-left: none;
    border-color: ${theme.color.progress_and_loading.background};  
    ${theme.radii.radius4};
  }
  .flw__wizard__stages__stage--active.flw__wizard__stages__stage.flw__container__stages__stage--active {
   color: ${theme.color.general.font.primary};
  }
  .flw__wizard__stages__stage--active.flw__wizard__stages__stage:before {
    border-color: ${theme.color.progress_and_loading.main};
  }
  `
}

export const getFlowableTabsStyles = ({ theme }: { theme: DefaultTheme }): string => {
  return `
      .flw__tabs__tab-item__button {
        font-weight: 400;
        font-size: 16px;
        background: ${theme.color.tabs.unselected_tab.background};
        color: ${theme.color.tabs.unselected_tab.font};
        text-transform: none;
      } 
      .flw__tabs__tab-item__button:hover {
        background: rgba(0, 0, 0, 0.02);
        border-radius: 12px 12px 0px 0px;
      }
      .flw__tabs__tabs-list:before {
        border-bottom-color: ${theme.color.general.dividers};
      }
      .flw__tabs__tab-item--active__button,
      .flw__tabs__tab-item--active__button:hover {
        font-weight: 600;
        border: none;
        border-radius: 4px 4px 0px 0px;
        color: ${theme.color.tabs.selected_tab.font};
      }
      .flw__tabs__tab-item.flw__tabs__tab-item--active:after {
        content: " ";
        width 100%;
        height: 3px;
        border-radius: 4px 4px 0px 0px;
        background-color: ${theme.color.tabs.selected_tab.selector};
        display: flex;
      }
  `
}
